module.exports = __webpack_public_path__ + "static/media/def.ec58ed2d.png";